import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AgreeOn } from 'src/app/models/agree-on';
import { Country } from 'src/app/models/country';
import { Member } from 'src/app/models/member';
import { CountryService } from 'src/app/services/country.service';
import { MainAppService } from 'src/app/services/main-app.service';
import { AgreeDialogComponent } from '../agree-dialog/agree-dialog.component';
import { DrawSurfaceComponent } from '../draw-surface/draw-surface.component';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {
  @ViewChild(DrawSurfaceComponent) drawSurfaceComponent: DrawSurfaceComponent;

  showTerms = false;
  showGDPR = false;
  agreedOnTerms:boolean = false;
  agreedOnGDPR:boolean = false;
  selectedCountry: any;
  member:Member = new Member();
  selectedSex: string;

  public countries: Array<Country>;
  public countryFields: Object = { text: 'name', value: 'code' };
  
  constructor(
    public dialog: MatDialog,
    public mainAppService: MainAppService,
    private countryService: CountryService, 
    public router : Router) { }

  ngOnInit(): void {
    this.countries = this.countryService.getCountries();
    if (!this.mainAppService.mainApp){
      this.mainAppService.getMainApp(0).subscribe(mainApp => {
        if (mainApp.responseData){
          this.mainAppService.mainApp = mainApp.responseData;
        }
      })
    }
  }

  showTermsDialog(){
    var agreeDto = new AgreeOn();
    agreeDto.title = this.mainAppService.mainApp.termsHeader
    agreeDto.text = this.mainAppService.mainApp.termsText
    const dialogRef = this.dialog.open(AgreeDialogComponent, {
      width: '400px',
      data: agreeDto
    });

    dialogRef.afterClosed().subscribe(result => {
     this.member.agreedOnTerms = result;
    });
  }

  showGDPRDialog(){
    var agreeDto = new AgreeOn();
    agreeDto.title = this.mainAppService.mainApp.gdprHeader
    agreeDto.text = this.mainAppService.mainApp.gdprText
    const dialogRef = this.dialog.open(AgreeDialogComponent, {
      width: '400px',
      data: agreeDto
    });

    dialogRef.afterClosed().subscribe(result => {
     this.member.agreedOnGDPR = result;
    });
  }

  hasSignatureData(){
    var signatureData = this.drawSurfaceComponent.drawcanvas.nativeElement.getContext('2d').getImageData(0,0,this.drawSurfaceComponent.drawcanvas.nativeElement.width,this.drawSurfaceComponent.drawcanvas.nativeElement.height).data.filter(byte => byte !== 0);
    return signatureData.length > 2000;
  }



  register(){
    this.member.sex = this.selectedSex
    this.member.signatureData = this.drawSurfaceComponent.drawcanvas.nativeElement.toDataURL("image/png");
    if (this.selectedCountry) this.member.countryCode = this.selectedCountry.code;

    if (this.member.signatureData.length >20000 && this.hasSignatureData()){
      this.mainAppService.isLoading = true;
      this.mainAppService.newMember(this.member).subscribe(result =>{
        this.mainAppService.isLoading = false;
        if (result && result.responseData){
          this.router.navigateByUrl("success");
        }
        else{
          var agreeDto = new AgreeOn();
          agreeDto.title = ""
          agreeDto.text = "Error registering";
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: '400px',
            data: agreeDto
          });
        }
      });
    }else {
      var agreeDto = new AgreeOn();
      agreeDto.title = ""
      agreeDto.text = this.mainAppService.mainApp.signatureError;
      const dialogRef = this.dialog.open(InfoDialogComponent, {
        width: '400px',
        data: agreeDto
      });
    }
  }

  goHome(){
    this.router.navigateByUrl("");
  }
}
